import Vue from 'vue'
import grid from './grid/index.vue'
import edit from './edit/index.vue'
import select from './select.vue'

Vue.component('app-segmento-grid', grid)
Vue.component('app-segmento-edit', edit)
Vue.component('app-segmento-select', select)
